var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "agreement_login"
  }, [_c('Checkbox', {
    attrs: {
      "value": _vm.value
    },
    on: {
      "on-change": _vm.onChange
    }
  }), _c('span', [_vm._v(` ${$t("cjxmz36", "已阅读并同意")} `), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.onClickAgreement('user');
      }
    }
  }, [_vm._v(` ${$t("f6rg5q4", "用户协议")} `)]), _vm._v(` ${$t("gp81", "和")} `), _c('a', {
    on: {
      "click": function ($event) {
        return _vm.onClickAgreement();
      }
    }
  }, [_vm._v($t("jhz6y04", "隐私政策"))])]), _c('Agreement', {
    ref: "Agreement"
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };